import { render, staticRenderFns } from "./payWechatResult.vue?vue&type=template&id=bf92a07e&scoped=true&"
import script from "./payWechatResult.vue?vue&type=script&lang=js&"
export * from "./payWechatResult.vue?vue&type=script&lang=js&"
import style0 from "./payWechatResult.vue?vue&type=style&index=0&id=bf92a07e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf92a07e",
  null
  
)

component.options.__file = "payWechatResult.vue"
export default component.exports